import { post,postAES } from "@/api/request"

export const aucSpec = params => postAES("/v3/special/detail", params)//拍卖专场
export const speCia = params => postAES("/v3/special/auctions/list", params)//拍卖专场
export const gotoSpec = params => postAES("/v3/special/auctions/list", params)//点击搜索进专场底层
